export default class StreamProfileService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntity(id, params) {
		return this.apiService.callGet('me/streamProfiles/' + id, params)
	}

	getEntities(params) {
		return this.apiService.callGet('me/streamProfiles', params)
	}

	createEntity(params) {
		return this.apiService.callPost('me/streamProfiles', params)
	}

	updateEntity(id, params) {
		return this.apiService.callPut('me/streamProfiles/' + id, params)
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('me/streamProfiles/' + id, params)
	}
}



// WEBPACK FOOTER //
// ./src/service/StreamProfileService.js